<template>
    <div class="project-settings__team settings-section">
        <p class="settings-section__heading">{{$t('project_settings.team.title')}}</p>
        <div class="settings-section__button">
            <button @click="showAddMemberModal">
                <svg
                    id="add-24px"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <path
                        id="Path_42"
                        data-name="Path 42"
                        d="M0,0H24V24H0Z"
                        fill="none"
                    />
                    <path
                        id="Path_43"
                        data-name="Path 43"
                        fill="#FF7366"
                        d="M19,13H13v6H11V13H5V11h6V5h2v6h6Z"
                    />
                </svg>
                <span>{{$t('project_settings.team.add_person')}}</span>
            </button>
        </div>
        <div class="project-settings__team-inner">
            <div v-for="(item,id) in projectDetails.members" class="person-box" :id="item.id" :key="item.id">
                <img
                    src="@/assets/icons/dialog-close.svg" width="24" height="24"
                    class="person-box__delete"
                    alt="Delete icon"
                    @click="removeMember(item)"
                    v-show="item.email"
                />
                <p class="person-box__position">{{$t('profile.role.'+item?.projectRole?.toLowerCase())}}</p>
                <div class="person-box__image">
                    <UserImage 
                        :user="item"
                        :src="item.imagePath"
                        width="115"
                        height="115"
                    />
                </div>
                <p class="person-box__name">{{item.firstName}} {{item.lastName}}</p>
                <p class="person-box__date">{{$t('project_settings.team.user_from')}} {{formatDate(item)}}</p>
                <div class="person-box__contact">
                    <p>{{$t('project_settings.team.phone')}}</p>
                    <a :href="`tel:${item.phone}`">{{item.phone}}</a>
                </div>
                <div class="person-box__contact">
                    <p>Adres email</p>
                    <a :href="`mailto:${item.email}`"
                    >{{item.email}}</a
                    >
                </div>
            </div>

        </div>
    </div>

    <add-member-to-project-modal
        ref="addMemberToProjectModal"
        @add-member="onPushMember"
    />

    <delete-project-member-modal
        ref="deleteMemberModal"
        @update-member="updateMember"
    />
    

</template>

<script >
import {ref, toRefs} from "vue";
import moment from "moment";


import DeleteProjectMemberModal from "@/components/architect/projectSettings/DeleteProjectMemberModal";
import AddMemberToProjectModal from "@/components/architect/projectSettings/AddMemberToProjectModal";
import UserImage from "@/components/image/UserImage.vue";

export default {
    name: "team",
    components: { DeleteProjectMemberModal, AddMemberToProjectModal, UserImage, UserImage },
    props: {
        project: {
            type: Object,
            default: null
        }
    },
    setup(props) {

        const errorMessage = ref('');
        const deleteMemberModal = ref('');
        const { project: projectDetails } = toRefs(props)

        const addMemberToProjectModal = ref('');



        function formatDate(item) {
            return item.createdAt ? moment(item.createdAt).format('DD.MM.YYYY') : ''
        }

        function showAddMemberModal() {
            addMemberToProjectModal.value.showModal(projectDetails.value.id);
        }
        function onPushMember(member) {
            projectDetails.value.members.push(member);
        }

        function removeMember(item) {
            deleteMemberModal.value.showModal(item, projectDetails.value.id);
        }

        function updateMember(email) {
            projectDetails.value.members = projectDetails.value.members.filter((item) => {
                return item.email != email;
            });
        }

        return {
            projectDetails,
            formatDate,
            errorMessage,
            removeMember,
            deleteMemberModal,
            updateMember,
            addMemberToProjectModal,
            onPushMember,
            showAddMemberModal,
        }
    }
}
</script>

<style scoped lang="scss">
.project-settings {
    &__team {
        &-inner {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 50px;
            flex-wrap: wrap;
            @media screen and (max-width: 1199px) {
                justify-content: center;
            }
        }
    }
}
.person-box {
    &__image {
        display: flex;
        object-fit: cover;
    }

    &__contact {
        a {
            display: block;
            min-height: 20px;
        }
    }
}

.project-add {
    &__button {
        button {
            &:hover {
                background: #e35748;
                cursor: pointer;
            }
        }
    }
}

.error-message {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    color: red;
    font-weight: 500;

}

</style>